import React, { useContext, useState, useEffect } from "react";

import busActive from "../icons/BusActive.png";
import { MapContext } from "../MapContext";
import ContextLayers from "./ContextLayers.js";
import HideSidebar from "./HideSideBar.js";
import ClearButton from "./ClearButton.js";
import DataInfo from "./DataInfoCard.js";

import { VTReach, hexGrid } from "../Services/serviceLayers.js";
import FeatureLayer from "@arcgis/core/layers/FeatureLayer";
import Graphic from "@arcgis/core/Graphic";
import * as geometryEngine from "@arcgis/core/geometry/geometryEngine";
import * as projection from "@arcgis/core/geometry/projection";

import { queryFeaturesOverLimit2k } from "../helpers/helper.js";


export default function VTMap() {
    const mapContext = useContext(MapContext);
    const [VTLayer, setVTLayer] = useState(0);
    const [selectedBusStop, setSelectedBusStop] = useState(null);
    const [aggregatedLayer, setAggregatedLayer] = useState(null);
    const [shouldClearBeActive, setShouldClearBeActive] = useState(false);

      // VT Pasiekiamumui isjungiami ijungiami aktualus layeriai
      useEffect(() => {
        
        let VTLayertemp = mapContext.state.dataContextLayers[7]
        setVTLayer(VTLayertemp); 
        
        mapContext.state.mapView.on("click", async function (event) {                   
            const layer = mapContext.state.dataContextLayers.forEach((element) => {
                if (element.visible) 
                    return element;
                    else return null;
                });
                var opts = {
                include: layer,
                };
                var data = await mapContext.state.mapView.hitTest(event, opts);
                data.results = data.results.filter((result) => {
                    try {
                        const matchingContextFeature = mapContext.state.dataContextLayers.find(
                            () => (VTLayertemp.url === result.layer.url)
                        );
                        return matchingContextFeature;
                    } catch (err) {
                        //console.error("queryFeatures failed", err);
                        return false;
                    }
                });
                console.log(data.results)
                if (data.results.length === 0) {
                    return;
                }
                setSelectedBusStop(data.results[0].graphic.attributes);
                
        });
        
        setTimeout(() => {
            mapContext.state.dataContextLayers[7].visible = true;
        }, 1000);
         
      },[])

      useEffect(() => {
        if (selectedBusStop === null || selectedBusStop === undefined) {
            return;
        }
        setShouldClearBeActive(true);
        // Remove previous aggregated layer if exists
        if (aggregatedLayer) {
            mapContext.state.mapView.map.remove(aggregatedLayer);
            setAggregatedLayer(null);
        }

        console.log("VTReach")
        console.log(selectedBusStop)
        let selectedId = selectedBusStop.id;
        let query = VTReach.createQuery();
        query.where = `id = '${selectedId}'`;

        console.log(query);
        queryFeaturesOverLimit2k(VTReach, query, mapContext).then(async (results) => {
            console.log(results);
            let filteredObjects = `(`

            results.forEach((feature) => {
                console.log(feature.attributes);
                filteredObjects += feature.attributes.OBJECTID + ',';
            });
            filteredObjects = filteredObjects.slice(0, -1) + `)`;

            console.log(filteredObjects);

            VTReach.definitionExpression = `id = '${selectedId}'`;

            mapContext.state.mapView.map.add(VTReach);

            // Aggregate points to hexagons client-side

            console.log("Starting client-side point aggregation...");
            console.log("Number of points:", results.length);
            console.log("points:", results);

            try {
                // Get the selected bus stop geometry
                const busStopQuery = VTLayer.createQuery();
                busStopQuery.where = `id = '${selectedId}'`;
                busStopQuery.returnGeometry = true;
                busStopQuery.outFields = ["*"];

                const busStopFeatures = await VTLayer.queryFeatures(busStopQuery);

                if (busStopFeatures.features.length === 0) {
                    console.log("No bus stop found");
                    return;
                }

                const busStopGeometry = busStopFeatures.features[0].geometry;
                console.log("Bus stop geometry:", busStopGeometry);

                // Create 1km buffer around the bus stop (1000 meters)
                const buffer1km = geometryEngine.buffer(busStopGeometry, 1000, "meters");
                console.log("1km buffer created");

                // Query hexagons that intersect with the 1km buffer
                const hexQuery = hexGrid.createQuery();
                hexQuery.geometry = buffer1km;
                hexQuery.spatialRelationship = "intersects";
                hexQuery.returnGeometry = true;
                hexQuery.outFields = ["*"];

                const hexagonFeatures = await hexGrid.queryFeatures(hexQuery);
                console.log("Hexagons within 1km:", hexagonFeatures.features.length);

                

                // Aggregate points to hexagons
                const hexagonCounts = new Map();

                // Load projection engine for coordinate transformation
                await projection.load();

                // Get the target spatial reference from hexagons
                const targetSpatialRef = hexagonFeatures.features[0]?.geometry?.spatialReference;
                console.log("Hexagon spatial reference:", targetSpatialRef?.wkid);

                hexagonFeatures.features.forEach((hexFeature) => {
                    const hexGeometry = hexFeature.geometry;
                    let pointCount = 0;

                    // Count points within this hexagon
                    results.forEach((pointFeature) => {
                        let pointGeometry = pointFeature.geometry;

                        // Project point to hexagon's spatial reference if they differ
                        if (targetSpatialRef && pointGeometry.spatialReference &&
                            pointGeometry.spatialReference.wkid !== targetSpatialRef.wkid) {
                            pointGeometry = projection.project(pointGeometry, targetSpatialRef);
                        }

                        if (pointGeometry && geometryEngine.contains(hexGeometry, pointGeometry)) {
                            console.log("Point", pointFeature.attributes, "is inside hexagon", hexFeature.attributes);
                            pointCount++;
                        }
                    });

                    // Only store hexagons that contain points
                    if (pointCount > 0) {
                        hexagonCounts.set(hexFeature.attributes.OBJECTID || hexFeature.attributes.objectid, {
                            geometry: hexGeometry,
                            count: pointCount,
                            attributes: hexFeature.attributes
                        });
                    }
                });

                console.log("Hexagons with points:", hexagonCounts.size);

                let maxPointCount = 5;
                // Print out hexagons and their point counts
                hexagonCounts.forEach((hexData, objectId) => {
                    console.log(`Hexagon OBJECTID ${objectId}: ${hexData.count} points`);
                    if (hexData.count > maxPointCount) {
                        maxPointCount = hexData.count;
                    }
                });

                if (hexagonCounts.size > 0) {
                    // Create graphics for hexagons with points
                    const aggregatedGraphics = Array.from(hexagonCounts.values()).map((hexData, index) => {
                        return new Graphic({
                            geometry: hexData.geometry,
                            attributes: {
                                OBJECTID: index + 1,
                                Point_Count: hexData.count,
                                ...hexData.attributes
                            }
                        });
                    });

                    // Esri color ramps - Blue 5
                    // Convert hex to RGB arrays for ArcGIS
                    const colors = [
                        [241, 238, 246, 0.8], // #f1eef6ff
                        [189, 201, 225, 0.8], // #bdc9e1ff
                        [116, 169, 207, 0.8], // #74a9cfff
                        [43, 140, 190, 0.8],  // #2b8cbeff
                        [4, 90, 141, 0.8]     // #045a8dff
                    ];

                    // Create a new feature layer with aggregated data
                    const newAggregatedLayer = new FeatureLayer({
                        title: "VT pasiekiamumo duomenys",
                        source: aggregatedGraphics,
                        objectIdField: "OBJECTID",
                        geometryType: "polygon",
                        fields: [
                            { name: "OBJECTID", type: "oid" },
                            { name: "Point_Count", type: "integer", alias: "Point Count" }
                        ],
                            minScale: 36112,
                            renderer: {
                            type: "simple",
                            symbol: {
                                type: "simple-fill",
                                color: colors[0],
                                outline: {
                                    color: [255, 255, 255, 1],
                                    width: 1
                                }
                            },
                            visualVariables: [{
                                type: "color",
                                field: "Point_Count",
                                stops: [
                                    { value: Math.floor(maxPointCount * 0.2), color: colors[0] },
                                    { value: Math.floor(maxPointCount * 0.4), color: colors[1] },
                                    { value: Math.floor(maxPointCount * 0.6), color: colors[2] },
                                    { value: Math.floor(maxPointCount * 0.8), color: colors[3] },
                                    { value: Math.floor(maxPointCount), color: colors[4] }
                                ]
                            }]
                        },
                        popupEnabled: false
                    });

                    setAggregatedLayer(newAggregatedLayer);
                    mapContext.state.mapView.map.add(newAggregatedLayer);
                    console.log("Aggregated layer added to map");
                } else {
                    console.log("No hexagons contain points");
                }
            } catch (error) {
                console.error("Client-side aggregation failed:", error);
                console.error("Error details:", error.message);
            }
        })
      }, [selectedBusStop])

      
      useEffect(() => {
        if (mapContext.state.clearFlag === 1) {                 
            setSelectedBusStop(null);
            setShouldClearBeActive(false);
            if (aggregatedLayer) {
                mapContext.state.mapView.map.remove(aggregatedLayer);
                setAggregatedLayer(null);
            }
            mapContext.dispatch({
                clearFlag: 0,
            });
        }
      }, [mapContext.state.clearFlag]);
      




    
    return (
        <>
        <DataInfo mapValue={4}></DataInfo>
        <div id={"MenuGrid"} className={"MenuColor VTMeniu"}>
            <div id="" className="IconContainer Icon Active staticHover" >
                    <img
                      id="BusIconImg"
                      className="ready3 img padding staticHover" 
                      src={busActive}
                      alt="bus"
                    ></img>
            </div>
        </div>
        <ClearButton customString={"Nėra parinktų stotelių"} enableButtonManually={shouldClearBeActive}/>
        <div class={"HideSidebarHeatmap"} id={"HideSidebarHeatmapId"}>
            <HideSidebar text={"Heatmap"}></HideSidebar>
        </div>
        <div id={"SidebarGridHeatmap"} className={"MenuColor"}>
            {<ContextLayers hideRows={[3]}></ContextLayers>}
        </div>
        </>
    )
}   